/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Autocomplete, Box, Grid, TextField, MenuItem,
} from '@mui/material';
import { AssigneeOption, Option } from './options';

type RemindersFiltersProps = {
  // Assignee Props
  assignees: AssigneeOption[];
  selectedAssignee: AssigneeOption;
  onAssigneeChange: (assignee: AssigneeOption | null) => void;
  // Status Filter Props
  statusOptions: Option[];
  selectedStatus: string;
  onStatusChange: (status: string) => void;
};

const RemindersFilters = ({
  // Assignee Props
  assignees,
  selectedAssignee,
  onAssigneeChange,
  // Status Filter Props
  statusOptions,
  selectedStatus,
  onStatusChange,
}: RemindersFiltersProps) => (
  <Box sx={{ mb: 4 }}>
    <Grid container columnSpacing={2} rowSpacing={2} alignItems="center">
      <Grid item mobile={12} desktop={3}>
        <Autocomplete
          getOptionKey={(o) => o.value}
          getOptionLabel={(o) => o.title}
          groupBy={(o) => o.status || ''}
          id="assignee"
          isOptionEqualToValue={(o, v) => o.value === v.value}
          onChange={(_, v) => onAssigneeChange(v)}
          options={assignees}
          renderInput={(params) => (
            <TextField {...params} label="Assignee" name="assignee" />
          )}
          value={selectedAssignee}
        />
      </Grid>
      <Grid item mobile={12} desktop={3}>
        <TextField
          fullWidth
          key="status-select"
          label="Status"
          name="status"
          onChange={(e) => onStatusChange(e.target.value)}
          select
          value={selectedStatus}
        >
          {statusOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.title}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  </Box>
);

export default RemindersFilters;
